<div class="relative">
  <textarea [(ngModel)]="value"
            (keydown.enter)="$event.preventDefault();submit()"
            class="chat-input-textarea bg-white p-1.5 pe-4.5 resize-none w-full shadow-lg rounded-lg border-1 border-border-primary-dark"
            placeholder="Stellen Sie eine Frage ..."
            rows="1"></textarea>
  <div class="absolute top-md end-md">
    <core-icon-button (triggered)="streaming ? stop() : submit()"
                      btnStyle="primary"
                      [filled]="streaming"
                      [icon]="streaming ? 'stop' : 'arrow_forward'"
    ></core-icon-button>
  </div>
</div>
